import type { PublicApiKey } from '#packages/apilib';
import type { createFeedbackApi } from './feedbackApi';

export const FeedbackApiKey: PublicApiKey<typeof createFeedbackApi> = {
  name: 'FeedbackApi',
  public: true,
};
